import * as z from "zod";

export const createShipStationApiIntegration = {
  name: "createShipStationApiIntegration" as const,
  input: z.object({ apiKey: z.string() }),
  output: z.object({ integrationId: z.string() }),
};
